import {useNavigate} from "react-router";
import {useMutation, useQuery, useQueryClient} from "react-query";
import http from "../../../Services/Network/http";
import {BsFillTrashFill,BsBootstrapReboot, BsCashCoin, BsFillBasket2Fill} from "react-icons/bs";
import {Button} from "reactstrap";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { DataGrid, GridColDef, GridToolbar, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid';

export const LeaderUserList = () => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const deleteMutation = useMutation(userId => http.remove(`/User/${userId}`), {
        onSuccess: () => {
            queryClient.invalidateQueries(["fetchUsers"]);
        },
        onError: (error : any) => {
            console.log(error.response.data);
        },
    });
    const sendWelcomeMessageMutation = useMutation(userId => http.get(`/User/ResetPasswordAndSendWelcomeMessage/${userId}`), {
        onSuccess: () => {
            toast("En velkomstmelding har nå blitt sendt til brukeren.", { type: "success" });
        },
        onError: (error : any) => {
            console.log(error.response.data);
        },
    });
    const { data: users } = useQuery(
        "fetchUsers",
        () => http.get(`/User/GetUsersForLeader`));

    const columns: GridColDef[] = [
    {
        headerName: 'Ansatt.Nr',
        field: 'username',
        sortable: true,
        flex: 0.5
    },
    {
        headerName: 'Etternavn',
        field: 'lastName',
        sortable: true,
        flex: 0.8
    },
    {
        headerName: 'Fornavn',
        field: 'firstName',
        sortable: true,
        flex: 1
    },
    {
        headerName: 'Telefon',
        field: 'cellPhone',
        flex: 0.6
    },
    {
        headerName: 'Kostnadssted',
        field: 'costAccount',
        valueGetter: (params: any) => params?.costAccountName,
        flex: 0.6
    },
    {
        headerName: '',
        align: 'right',
        field: 'Valg',
        flex: 0.6,
        renderCell: (params: any) => (
            <>
                <BsFillBasket2Fill cursor="Pointer" onClick={(e) => { e.stopPropagation(); navigate(`/account/leader/user/${params.row.userId}/orders`) }} />
                &nbsp;&nbsp;&nbsp;
                <BsCashCoin cursor="Pointer" onClick={(e) => { e.stopPropagation(); navigate(`/account/leader/user/credit/${params.row.userId}`) }} />
            </>)
    }];
    
    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <div style={{ flex: 1 }} />
                <GridToolbarQuickFilter debounceMs={150} />
            </GridToolbarContainer>
        );
    }

    return (
        <div>
            <h2 style={{ float: 'left' }}>Leder &gt; Brukere</h2>
            <div className="clearfix"></div>
            <DataGrid
                pageSizeOptions={[10, 20, 25, 50, 100]}
                density="compact"
                pagination={true}
                columns={columns}
                slots={{ toolbar: CustomToolbar }}
                onRowClick={(data) => navigate(`/account/leader/user/${data.row.userId}`)}
                initialState={{
                    pagination: { paginationModel: { pageSize: 20 } },
                    columns: {
                        columnVisibilityModel: {
                        },
                    },
                }}

                getRowId={(row) => row.userId}
                rows={(users || [])}
            />
            
        </div>
    );
}